document.addEventListener("DOMContentLoaded", async function () {
  // Cart scoped values.
  const scopingClassName = "cart-container";
  const dialog = document.querySelector("dialog.cart-container");
  const emptyCartContainer = document.querySelector(
    `.${scopingClassName} .empty-cart-container`
  );
  const nonEmptyCartContainer = document.querySelector(
    `.${scopingClassName} .non-empty-cart-container`
  );
  const cartItemsContainer = document.querySelector(
    ".cart-container .cart-items-container"
  );
  const cartTotalValue = document.querySelector(
    ".cart-footer-container .subtotal-container .subtotal-value"
  );

  // 0. Attach one-time event listeners.
  const keepBrowingBtn = document.querySelector(
    `.${scopingClassName} .cta-btn.keep-browsing`
  );
  keepBrowingBtn.addEventListener("click", closeCartDialog);
  const closeBtns = document.querySelectorAll(
    `.${scopingClassName} .cart-dialog-close-btn`
  );
  closeBtns.forEach((btn) => btn.addEventListener("click", closeCartDialog));
  Shopify.eventBus.on('add-variant-to-cart', ()=>{
    dialog.showModal();
  });

  // 1. Create a MutationObserver which runs whenever cart dialog is opened.
  var attributeObserverOnDialog = new MutationObserver(function (mutations) {
    mutations.forEach(async function (mutation) {
      console.log(mutation.target);

      if (mutation.type === "attributes") {
        console.log("attributes changed");

        if (mutation.target.open) {
          console.log("dialog is open");

          handleCartDialogOpen();
        } else {
          console.log("dialog is closed");
        }
      }
    });
  });

  attributeObserverOnDialog.observe(dialog, { attributes: true });

  // 2. Initialize Cart data and display.
  await initializeCartDialog();

  // Scoped fn defs.
  async function handleCartDialogOpen() {
    // Fetch fresh cart data.
    Shopify.cart = await Shopify.fetchCart();
    // Update component/scope with fresh cart data.
    // Construct Dialog InnerHtml.
    updateCartDisplay(Shopify.cart);
  }

  async function initializeCartDialog() {
    // Fetch initial cart data. Initialize component/scope with cart data.
    Shopify.cart = await Shopify.fetchCart();
    // Construct Dialog InnerHtml. Update cart dialog with initial cart data1.
    updateCartDisplay(Shopify.cart);
  }

  function closeCartDialog() {
    dialog.close();
    openCheck(dialog);
  }

  function openCheck(dialog) {
    if (dialog.open) {
      console.log("Dialog open");
    } else {
      console.log("Dialog closed");
    }
  }

  // Function to remove an item from the cart
  async function removeLineItemFromCart(lineItemId) {
    const cart = await Shopify.removeLineItemFromCart(lineItemId);
    Shopify.cart = cart;

    // Got the new cart. Update UI with it.
    updateCartDisplay(cart);
    console.log("Item removed from cart:", cart);
  }

  // Event listener for remove button clicks
  // document
  //   .querySelectorAll(".cart-item-container .cart-item-remove-btn")
  //   .forEach((button) => {
  //     button.addEventListener("click", (event) => {
  //       const lineItemId = event.target.getAttribute("data-line-item-id");
  //       removeLineItemFromCart(lineItemId);
  //     });
  //   });

  // Function to update the cart display after removing an item
  function updateCartDisplay(cart) {
    // Clear current cart items
    cartItemsContainer.innerHTML = "";

    Shopify.eventBus.emit("update-cart-badge", cart.item_count);

    // Check if cart is empty
    if (cart.items.length === 0) {
      emptyCartContainer.classList.remove("hide");
      nonEmptyCartContainer.classList.add("hide");
      return;
    }
    
    emptyCartContainer.classList.add("hide");
    nonEmptyCartContainer.classList.remove("hide");

    // Render each cart item
    cart.items.forEach((item) => {
      const cartItem = document.createElement("div");
      cartItem.className = "cart-item-container";

      cartItem.innerHTML = `
          <div class="cart-item-main-details-container">
            <div class="cart-item-thumbnail-image-container">
              <img src="${
                item?.featured_image?.url
              }" alt="" class="cart-item-thumbnail-image">
            </div>
            <div class="cart-item-details-container">
              <div class="cart-item-title-variant-count-container column-1">
                <div class="cart-item-title">${item.product_title}</div>
                <div class="cart-item-variant-title">${item.variant_title}</div>
                <div class="cart-item-count-container">
                  <div class="cart-item-count-decrement" data-quantity=${item.quantity} data-line-item-id=${
                    item.id
                  }>-</div>
                  <div class="cart-item-count-value">${item.quantity}</div>
                  <div class="cart-item-count-increment" data-quantity=${item.quantity} data-line-item-id=${
                    item.id
                  }>+</div>
                </div>
              </div>
              <div class="cart-item-price-remove-container column-2">
                <div class="cart-item-price">${formatShopifyPriceToINRString(
                  item.final_price
                )}</div>
                <button class="cart-item-remove-btn" data-line-item-id=${
                  item.id
                }>Remove</button>
              </div>
            </div>
          </div>   
      `;

      // Update event listeners.
      // Attach event listener to the new remove button
      cartItem
        .querySelector(".cart-item-remove-btn")
        .addEventListener("click", (event) => {
          const lineItemId = event.target.getAttribute("data-line-item-id");
          removeLineItemFromCart(lineItemId);
        });
      cartItem
        .querySelector(".cart-item-count-decrement")
        .addEventListener("click", async (event) => {
          console.log("decrement clicked.");
          const lineItemId = event.target.dataset["lineItemId"]; // line item id is the same as variant id.
          let quantity = event.target.dataset['quantity'];
          quantity--;
          event.target.nextElementSibling.textContent = quantity;

          // Update in BE.
          await Shopify.updateCartLineItemQuantity(lineItemId, quantity);

          // Fetch new cart data.
          const cart = await Shopify.fetchCart();

          // Update UI with fresh cart data.
          updateCartDisplay(cart);
        });
      cartItem
        .querySelector(".cart-item-count-increment")
        .addEventListener("click", async (event) => {
          console.log("increment clicked.");
          const lineItemId = event.target.dataset["lineItemId"]; // line item id is the same as variant id.
          let quantity = event.target.dataset['quantity'];
          quantity++;
          event.target.previousElementSibling.textContent = quantity;

          // Update in BE.
          await Shopify.updateCartLineItemQuantity(lineItemId, quantity);

          // Fetch new cart data.
          const cart = await Shopify.fetchCart();

          // Update UI with fresh cart data.
          updateCartDisplay(cart);
        });

      // Append the cart item to the container
      cartItemsContainer.appendChild(cartItem);
    });

    // Update the cart total
    // const total = (cart.total_price / 100).toFixed(2);
    // cartTotal.textContent = `$${total}`;
    cartTotalValue.textContent = formatShopifyPriceToINRString(
      cart.total_price
    );
  }
});

/** Global cart functions. */
// Create a simple event bus
Shopify.eventBus = {
  events: {},

  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);
  },

  emit(eventName, data) {
    if (this.events[eventName]) {
      this.events[eventName].forEach((callback) => callback(data));
    }
  },

  off(eventName, callback) {
    if (this.events[eventName]) {
      this.events[eventName] = this.events[eventName].filter(
        (cb) => cb !== callback
      );
    }
  },
};

Shopify.addVariantToCart = async function (variant_id, qty, selling_plan) {
  console.log(`Shopify.addVariantToCart with variant_id ${variant_id}`);

  let formData = {
    items: [
      {
        id: variant_id,
        quantity: 1,
      },
    ],
  };

  const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  if (!res.ok) {
    console.error(res);
    return;
  }

  const cartItems = await res.json();
  return cartItems;
};

Shopify.removeLineItemFromCart = async function (line_item_id) {
  const res = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: line_item_id,
      quantity: 0,
    }),
  });

  if (!res.ok) {
    console.error(res);
    return;
  }

  Shopify.cart = await res.json();
  return Shopify.cart;
};

Shopify.updateCartLineItemQuantity = async function (line_item_id, quantity) {
  const res = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: line_item_id,
      quantity: quantity,
    }),
  });

  if (!res.ok) {
    console.error(res);
    return;
  }

  Shopify.cart = await res.json();
  return Shopify.cart;
};

Shopify.fetchCart = async function () {
  const res = await fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    console.error(res);
    return;
  }

  const cart = await res.json();
  console.log("Latest cart data:", cart);
  return cart; // This returns the latest cart object
};

/** Global utility functions. */
function money_without_trailing_zeros(amount) {
  // Convert to fixed two-decimal string
  let amountStr = parseFloat(amount).toFixed(2);
  // Remove trailing zeros if they exist
  return amountStr.includes(".") ? amountStr.replace(/\.?0+$/, "") : amountStr;
}

function formatPriceNumberToString(number) {
  // Divide by 100 and round to remove any cents
  const dividedNumber = Math.floor(number / 100);
  // Convert to string with commas as thousands separator
  return dividedNumber.toLocaleString("en-IN");
}

function formatShopifyPriceToINRString(number) {
  return `₹ ${formatPriceNumberToString(number)}`;
}
